import apiFetch from '../apiFetch'

export default function (token) {

  return apiFetch({ endPoint: 'Favorites', method: 'GET', body: null, token: token })
}
